import React from "react";
import {observer} from "mobx-react-lite";
import styles from "./MultiplayerToggle.module.scss";
import {useCsContext} from "../../state/CsInstance";

import {ErrorBoundary} from "react-error-boundary";
import ErrorComponent from "../ErrorComponent/ErrorComponent";

import {faChalkboardUser} from "@fortawesome/sharp-solid-svg-icons/faChalkboardUser";
import {faScreenUsers} from "@fortawesome/sharp-regular-svg-icons/faScreenUsers";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

// This interface allows us to pass variables and callback function into a component
type Props = {};

/**
 * The title of the current activity.  Normally sits above the theater.
 */
const MultiplayerToggle: React.FC<Props> = () => {
	const csInstance = useCsContext();

	function setShowMultiplayer(isMultiplayer: boolean) {
		csInstance.multiplayerStore.showMultiplayer = isMultiplayer;
	}

	return (
		<ErrorBoundary FallbackComponent={ErrorComponent}>
			<div className={styles.multiplayerToggleContainer}>
				<button
					onClick={() => setShowMultiplayer(false)}
					className={[
						csInstance.multiplayerStore.showMultiplayer
							? styles.multiplayerToggleOff
							: styles.multiplayerToggleOn,
						styles.multiplayerToggleLeft,
						styles.multiplayerToggle,
					].join(" ")}
				>
					<FontAwesomeIcon icon={faChalkboardUser} />
					<span>Student</span>
				</button>
				<button
					onClick={() => setShowMultiplayer(true)}
					className={[
						csInstance.multiplayerStore.showMultiplayer
							? styles.multiplayerToggleOn
							: styles.multiplayerToggleOff,
						styles.multiplayerToggleRight,
						styles.multiplayerToggle,
					].join(" ")}
				>
					<FontAwesomeIcon icon={faScreenUsers} />
					<span>Classroom</span>
				</button>
			</div>
		</ErrorBoundary>
	);
};

export default observer(MultiplayerToggle);
